interface StatusBadgeProps {
  status: string
  variant?: 'session' | 'worker'
}

const sessionColors: Record<string, string> = {
  active: 'status-badge--green',
  completed: 'status-badge--indigo',
  closed: 'status-badge--gray',
  error: 'status-badge--red',
}

const workerColors: Record<string, string> = {
  active: 'status-badge--green',
  ready: 'status-badge--blue',
  initializing: 'status-badge--yellow',
  idle: 'status-badge--gray',
  error: 'status-badge--red',
  busy: 'status-badge--indigo',
}

export function StatusBadge({ status, variant = 'session' }: StatusBadgeProps) {
  const map = variant === 'worker' ? workerColors : sessionColors
  const colorClass = map[status.toLowerCase()] ?? 'status-badge--gray'
  return <span className={`status-badge ${colorClass}`}>{status}</span>
}